document.documentElement.classList.remove('no-js');

(function headerScroll() {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  function setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  var lastScrollY = window.scrollY;
  var threshold = 10;
  var ticking = false;

  function onScroll() {
    var currentScrollY = window.scrollY;

    if (document.body.classList.contains('search-open')) {
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    if (currentScrollY <= 0) {
      header.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    if (Math.abs(currentScrollY - lastScrollY) >= threshold) {
      if (currentScrollY > lastScrollY) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastScrollY = currentScrollY;
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();

(function quickAdd() {
  var cartCount = document.querySelector('[data-cart-count]');
  var modal = document.querySelector('[data-quick-add-modal]');
  var modalTitle = modal && modal.querySelector('[data-quick-add-title]');
  var modalLabel = modal && modal.querySelector('[data-quick-add-option-label]');
  var modalValues = modal && modal.querySelector('[data-quick-add-values]');
  var modalError = modal && modal.querySelector('[data-quick-add-error]');
  var modalSubmit = modal && modal.querySelector('[data-quick-add-submit]');
  var selectedVariantId = null;
  var activeButton = null;

  function addToCart(variantId, button) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) { return response.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.setAttribute('data-count', cart.item_count);
        }
        if (button) {
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 1500);
        }
      });
  }

  function openSizeModal(button) {
    if (!modal) return;
    activeButton = button;
    selectedVariantId = null;

    var variants = [];
    try { variants = JSON.parse(button.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }
    var optionIndex = parseInt(button.getAttribute('data-size-option-index'), 10) || 0;

    if (modalTitle) modalTitle.textContent = button.getAttribute('data-product-title') || '';
    if (modalLabel) modalLabel.textContent = button.getAttribute('data-size-option-name') || '';
    if (modalError) modalError.hidden = true;
    if (modalSubmit) modalSubmit.disabled = false;
    if (modalValues) {
      modalValues.innerHTML = '';
      variants.forEach(function (variant) {
        var value = variant.options && variant.options[optionIndex];
        if (!value) return;
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'option-value';
        el.textContent = value;
        if (!variant.available) el.disabled = true;
        el.addEventListener('click', function () {
          modalValues.querySelectorAll('.option-value').forEach(function (b) { b.classList.remove('is-selected'); });
          el.classList.add('is-selected');
          selectedVariantId = variant.id;
          if (modalError) modalError.hidden = true;
        });
        modalValues.appendChild(el);
      });
    }

    modal.hidden = false;
    document.body.classList.add('quick-add-open');
  }

  function closeSizeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('quick-add-open');
    activeButton = null;
  }

  document.querySelectorAll('[data-quick-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return;

      if (button.hasAttribute('data-quick-add-sizes')) {
        openSizeModal(button);
        return;
      }

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;
      button.disabled = true;
      addToCart(variantId, button).catch(function () {}).finally(function () { button.disabled = false; });
    });
  });

  if (modal) {
    modal.querySelectorAll('[data-quick-add-close]').forEach(function (el) {
      el.addEventListener('click', closeSizeModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeSizeModal();
    });
    modalSubmit && modalSubmit.addEventListener('click', function () {
      if (!selectedVariantId) {
        if (modalError) modalError.hidden = false;
        return;
      }
      modalSubmit.disabled = true;
      addToCart(selectedVariantId, activeButton)
        .then(closeSizeModal)
        .catch(function () {})
        .finally(function () { modalSubmit.disabled = false; });
    });
  }
})();

(function collectionFilters() {
  var toggle = document.querySelector('[data-filters-toggle]');
  var sidebar = document.querySelector('.collection-sidebar');
  if (!toggle || !sidebar) return;
  toggle.addEventListener('click', function () {
    sidebar.classList.toggle('is-open');
  });
})();

(function predictiveSearch() {
  var toggle = document.querySelector('[data-search-toggle]');
  var overlay = document.querySelector('[data-search-overlay]');
  var backdrop = document.querySelector('[data-search-backdrop]');
  var closeBtn = document.querySelector('[data-search-close]');
  var input = document.querySelector('[data-search-input]');
  var resultsEl = document.querySelector('[data-search-results]');
  if (!toggle || !overlay || !input || !resultsEl) return;

  var header = document.querySelector('[data-header]');
  var scrollY = 0;

  function openSearch() {
    scrollY = window.scrollY;
    document.body.classList.add('search-open');
    document.body.style.top = '-' + scrollY + 'px';
    if (header) header.classList.remove('is-hidden');
    overlay.hidden = false;
    if (backdrop) backdrop.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () { input.focus(); }, 50);
  }

  function closeSearch() {
    document.body.classList.remove('search-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
    overlay.hidden = true;
    if (backdrop) backdrop.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    if (overlay.hidden) {
      openSearch();
    } else {
      closeSearch();
    }
  });
  closeBtn && closeBtn.addEventListener('click', closeSearch);
  backdrop && backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !overlay.hidden) closeSearch();
  });

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function renderProducts(products) {
    if (!products || products.length === 0) {
      resultsEl.innerHTML = '<p class="search-overlay__empty">' + resultsEl.getAttribute('data-empty-text') + '</p>';
      return;
    }
    var cards = products.map(function (product) {
      var image = product.image ? '<img src="' + escapeHtml(product.image) + '&width=400" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '';
      return (
        '<a href="' + escapeHtml(product.url) + '" class="predictive-card">' +
          '<span class="predictive-card__media">' + image + '</span>' +
          '<span class="predictive-card__info">' +
            '<span class="predictive-card__title">' + escapeHtml(product.title) + '</span>' +
            '<span class="predictive-card__price">' + product.price + '</span>' +
          '</span>' +
        '</a>'
      );
    }).join('');
    resultsEl.innerHTML = '<div class="predictive-search-grid">' + cards + '</div>';
  }

  var debounceTimer;
  input.addEventListener('input', function () {
    var term = input.value.trim();
    window.clearTimeout(debounceTimer);

    if (term.length < 2) {
      resultsEl.innerHTML = '';
      return;
    }

    debounceTimer = window.setTimeout(function () {
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (input.value.trim() !== term) return;
          var products = data && data.resources && data.resources.results ? data.resources.results.products : [];
          renderProducts(products);
        })
        .catch(function () {
          resultsEl.innerHTML = '';
        });
    }, 300);
  });
})();

(function menuToggle() {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;

  var levels = nav.querySelectorAll('[data-nav-level]');
  var rootLevel = nav.querySelector('[data-nav-level-root]');

  function showLevel(level) {
    levels.forEach(function (el) { el.classList.toggle('is-active', el === level); });
  }

  function openNav() {
    nav.classList.add('is-open');
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
  }

  function closeNav() {
    nav.classList.remove('is-open');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
    if (rootLevel) showLevel(rootLevel);
  }

  toggle.addEventListener('click', function () {
    if (nav.classList.contains('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  nav.querySelectorAll('[data-nav-close]').forEach(function (el) {
    el.addEventListener('click', closeNav);
  });

  nav.querySelectorAll('[data-nav-open-level]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      if (el.tagName === 'A' && !window.matchMedia('(min-width: 990px)').matches) {
        event.preventDefault();
      } else if (el.tagName === 'A') {
        return;
      }
      var index = el.getAttribute('data-nav-open-level');
      var target = nav.querySelector('[data-nav-level-index="' + index + '"]');
      if (target) showLevel(target);
    });
  });

  nav.querySelectorAll('[data-nav-back]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (rootLevel) showLevel(rootLevel);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
  });
})();

(function quantitySelectors() {
  document.querySelectorAll('.quantity-selector').forEach(function (wrapper) {
    var input = wrapper.querySelector('[data-quantity-input]');
    var decrease = wrapper.querySelector('[data-quantity-decrease]');
    var increase = wrapper.querySelector('[data-quantity-increase]');
    if (!input) return;
    decrease && decrease.addEventListener('click', function () {
      var value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = value;
      input.dispatchEvent(new Event('change'));
    });
    increase && increase.addEventListener('click', function () {
      var value = (parseInt(input.value, 10) || 1) + 1;
      input.value = value;
      input.dispatchEvent(new Event('change'));
    });
  });
})();

(function variantOptions() {
  document.querySelectorAll('[data-option-index]').forEach(function (optionGroup) {
    var index = optionGroup.getAttribute('data-option-index');
    var form = optionGroup.closest('form');
    var select = form ? form.querySelector('[data-variant-select]') : null;

    optionGroup.querySelectorAll('[data-option-value]').forEach(function (button) {
      button.addEventListener('click', function () {
        optionGroup.querySelectorAll('[data-option-value]').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });
        button.classList.add('is-selected');

        if (!select || !form) return;
        var selectedValues = [];
        form.querySelectorAll('[data-option-index]').forEach(function (group) {
          var active = group.querySelector('.is-selected');
          selectedValues[parseInt(group.getAttribute('data-option-index'), 10)] = active ? active.getAttribute('data-option-value') : null;
        });

        var options = Array.from(select.options);
        var match = options.find(function (option) {
          var parts = option.textContent.trim().split(' / ');
          return selectedValues.every(function (value, i) {
            return value === null || parts[i] === value;
          });
        });
        if (match) select.value = match.value;
      });
    });
  });
})();

(function sizeGuideModal() {
  var modal = document.querySelector('[data-size-guide-modal]');
  var openBtn = document.querySelector('[data-size-guide-open]');
  if (!modal || !openBtn) return;

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('size-guide-open');
  }
  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('size-guide-open');
  }

  openBtn.addEventListener('click', openModal);
  modal.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  modal.querySelectorAll('[data-size-guide-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-size-guide-tab');
      modal.querySelectorAll('[data-size-guide-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      modal.querySelectorAll('[data-size-guide-panel]').forEach(function (panel) {
        var isMatch = panel.getAttribute('data-size-guide-panel') === target;
        panel.hidden = !isMatch;
        panel.classList.toggle('is-active', isMatch);
      });
    });
  });
})();

(function policyModals() {
  function setup(prefix) {
    var modal = document.querySelector('[data-' + prefix + '-modal]');
    var openBtn = document.querySelector('[data-' + prefix + '-open]');
    if (!modal || !openBtn) return;

    function openModal() {
      modal.hidden = false;
      document.body.classList.add('warranty-open');
    }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('warranty-open');
    }

    openBtn.addEventListener('click', openModal);
    modal.querySelectorAll('[data-' + prefix + '-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    modal.querySelectorAll('[data-' + prefix + '-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-' + prefix + '-tab');
        modal.querySelectorAll('[data-' + prefix + '-tab]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        modal.querySelectorAll('[data-' + prefix + '-panel]').forEach(function (panel) {
          var isMatch = panel.getAttribute('data-' + prefix + '-panel') === target;
          panel.hidden = !isMatch;
          panel.classList.toggle('is-active', isMatch);
        });
      });
    });
  }

  setup('warranty');
  setup('care');
})();

(function homeBanner() {
  document.querySelectorAll('[data-home-banner]').forEach(function (banner) {
    var track = banner.querySelector('[data-home-banner-track]');
    var dots = banner.querySelectorAll('[data-home-banner-dot]');
    var prev = banner.querySelector('[data-home-banner-prev]');
    var next = banner.querySelector('[data-home-banner-next]');
    if (!track) return;
    var slides = track.querySelectorAll('.home-banner__slide');
    if (slides.length < 2) return;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function currentIndex() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var closestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = index;
        }
      });
      return closest;
    }

    function updateActiveDot() {
      var index = currentIndex();
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    prev && prev.addEventListener('click', function () {
      goTo(currentIndex() - 1);
    });
    next && next.addEventListener('click', function () {
      goTo(currentIndex() + 1);
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10) || 0);
      });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 100);
    });
  });
})();

(function cartPage() {
  var form = document.querySelector('[data-cart-form]');
  if (!form) return;

  form.querySelectorAll('[data-cart-update]').forEach(function (input) {
    input.addEventListener('change', function () {
      form.submit();
    });
  });

  form.querySelectorAll('[data-cart-remove]').forEach(function (button) {
    button.addEventListener('click', function () {
      var line = button.closest('.cart-line');
      var input = line ? line.querySelector('[data-cart-update]') : null;
      if (input) {
        input.value = 0;
        form.submit();
      }
    });
  });

})();

